module.exports = __webpack_public_path__ + "images/open-book_emoji.png";